import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import env from 'src/env';
import actions from '../actions';

function normalizeRejectPayload(httpStatus, data) {
  if (data == null || typeof data !== 'object') {
    return {
      message: typeof data === 'string' ? data : `Request failed (${httpStatus})`,
      status: httpStatus,
    };
  }
  return {
    message: data.message || `Request failed (${httpStatus})`,
    error: data.error,
    status: data.status ?? httpStatus,
  };
}

export const postShipment = createAsyncThunk(
  'shipment_modal/postShipment',
  async (arg, thunkAPI) => {
    const state = thunkAPI.getState();
    // ticketId (numeric) is used for upload refId; rmaDocumentId (string) for Strapi v5 PUT path
    const ticketId = state.rma?.data?.id;
    const rmaDocumentId = state.rma?.data?.documentId;
    if (!ticketId) return thunkAPI.rejectWithValue({ message: 'No RMA loaded' });
    const { articles, shipment, shipment_details, deliverynote } = state.shipment_modal;

    try {
      const response = await axios.post(
        `${env.REACT_APP_SSO_BACKEND}/shipment/`,
        {
          provider: 'dhl',
          user_action: 'create',
          ticketId: ticketId,
          rmaDocumentId: rmaDocumentId,
          data: {
            shipment: {
              ...shipment,
              shipment_details,
            },
            deliverynote: {
              rmaNumber: deliverynote.rmaNumber,
              shipping: {
                name: [shipment.name1, shipment.name2, shipment.name3]
                  .filter((n) => n && String(n).trim() !== '')
                  .join(' '),
                address: `${shipment.streetName} ${shipment.streetNumber}`.trim(),
                city: `${shipment.zip} ${shipment.city}`.trim(),
                state: '',
                country: shipment.countryISOCode || '',
              },
              items: articles,
            },
          },
        },
        {
          headers: {
            jwt: localStorage.getItem('microsoftJWT'),
          },
          validateStatus: () => true,
        }
      );

      const { status: httpStatus, data } = response;

      if (httpStatus === 200 && data?.status === 200) {
        thunkAPI.dispatch(
          actions.RMA.putRMA({
            rmaID: ticketId,
            updateData: { status: 'close' },
          })
        );
        return data;
      }

      return thunkAPI.rejectWithValue(normalizeRejectPayload(httpStatus, data));
    } catch (err) {
      const res = err.response;
      if (res?.data) {
        return thunkAPI.rejectWithValue(normalizeRejectPayload(res.status, res.data));
      }
      return thunkAPI.rejectWithValue({
        message: err.message || 'Network error',
      });
    }
  }
);
